import { el } from 'redom';

import { isVideoMime } from '../../../../utilities';

class AttachmentViewer {

  constructor(configuration) {

    this.attachment = configuration.attachment;
    this.onClose = configuration.onClose;

    this.contentContainer = el('.attachment-viewer-content-container', [
      this.renderAttachment()
    ]);

    this.el = el('.attachment-viewer-main', {
      tabindex: 0,
      onclick: this.handleCloseButtonClick.bind(this),
      onkeydown: this.handleKeyUp.bind(this),
    }, [
      this.contentContainer
    ]);

  }

  onmount() {
    this.el.focus();
  }

  handleCloseButtonClick(event) {

    event.stopPropagation();
    if (event.target !== this.el) {
      return;
    }

    event.preventDefault();

    this.onClose();

    return false;

  }

  handleKeyUp(event) {

    if (event.key !== 'Escape') {
      return;
    }

    this.onClose();

  }

  renderAttachment() {

    const mimetype = this.attachment.mimetype;

    if (isVideoMime(mimetype) === true) {
      return el('video.attachment-viewer-video', {
        controls: true,
        preload: 'metadata',
        src: this.attachment.url
      });
    }

    return el('img.attachment-viewer-image', {
      src: this.attachment.url
    });

  }

}

export default AttachmentViewer;